import {Icon} from '@gisatcz/ptr-atoms';
import PropTypes from 'prop-types';

const DataWrapper = ({noDataInfo, children}) => {
	return (
		<div className="insar-ControlPanel-data-wrapper">
			{children ? (
				children
			) : (
				<div className="cta">
					<Icon icon="back" />
					<span>{noDataInfo}</span>
				</div>
			)}
		</div>
	);
};

DataWrapper.propTypes = {
	noDataInfo: PropTypes.string,
	children: PropTypes.node,
};

export default DataWrapper;
